import React from "react";
import LeadsListTable from "../components/table/LeadsListTable";

const ChannelPartnerLeadsPage = () => {
    return (
        <>
            <LeadsListTable
                title={"Channel Partner Leads List"}
                name={"Channel Partner Lead"}
                role={null}
                viewMode="channelPartner"
            />
        </>
    );
};

export default ChannelPartnerLeadsPage;